module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Tools-071f928a542fb51bacceb18de250798f.svg";